import { Box, Dialog, DialogActions, DialogContent, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';
import CustomDialogTitle from 'components/modal/CustomDialogTitle';
import GrowDialogTransition from 'components/modal/GrowDialogTransition';
import WriteWithAIForm from './WriteWithAIForm';
import { WriteWithAIOnSelectOptions, WriteWithAITabName } from '../../hooks/useWriteWithAI';
// import WriteWithAIPromptHistory from './WriteWithAIPromptHistory';
import { useRef } from 'react';
import { ReactComponent as SparkIcon } from 'assets/icons/auto-generated.svg';
import WriteWithAIActionButtons from './WriteWithAIActionButtons';

type WriteWithAIModalProps = {
  open: boolean;
  tab: WriteWithAITabName;
  closeModal: () => void;
  onGenerate: () => void;
  onSelect: (options: WriteWithAIOnSelectOptions) => void;
  onRetry: (options: { text: string }) => void;
};

function WriteWithAIModal({
  open,
  tab,
  closeModal,
  onGenerate,
  onSelect,
  onRetry,
}: WriteWithAIModalProps) {
  const containerRef = useRef<HTMLDivElement | null>(null);

  return (
    <Dialog
      open={open}
      fullWidth
      maxWidth="md"
      aria-labelledby="dialog-title"
      aria-describedby="dialog-description"
      TransitionComponent={GrowDialogTransition}
      sx={{ '& .MuiPaper-root': { maxHeight: '80%', minHeight: '60%' } }}
    >
      <CustomDialogTitle
        onClose={closeModal}
        id="dialog-title"
        sx={{ textAlign: 'center', borderBottom: 'none', pb: 1 }}
      >
        <Box sx={{ display: 'flex', alignItems: 'center' }}>
          <SparkIcon width={24} height={24} />
          <Title>Write with AI</Title>
        </Box>
        <Note>Polish your information into engaging posts with our AI writing assistant.</Note>
      </CustomDialogTitle>
      <DialogContent id="dialog-description" ref={containerRef}>
        {/* <WriteWithAIPromptHistory
              onSelect={onSelect}
              onRetry={(options) => {
                onRetry(options);
                setTimeout(() => {
                  if (containerRef.current) {
                    containerRef.current.scrollIntoView({
                      behavior: 'smooth',
                      block: 'end',
                    });
                  }
                }, 100);
              }}
            /> */}
        <WriteWithAIForm tab={tab} />
        {/* <Box sx={{ display: 'flex', justifyContent: 'center', marginTop: 1 }}>
                <Tabs
                  value={tab}
                  onChange={(_: unknown, newValue: TabNameType) => {
                    setTab(newValue);
                    reset();
                  }}
                  TabIndicatorProps={{
                    style: {
                      display: 'none',
                    },
                  }}
                  sx={{
                    border: 'none',
                    '& .MuiTab-root': {
                      margin: 0,
                      border: 'none',
                      backgroundColor: '#F5F6F7',
                      color: '#35374F',
                      textTransform: 'none',
                      padding: '8px, 12px, 8px, 12px',
                      fontWeight: 700,
                      '&:hover': {
                        backgroundColor: '#b3b3b3',
                      },
                      '&.Mui-selected': {
                        backgroundColor: '#35374F',
                        color: '#FFFFFF',
                      },
                    },
                  }}
                >
                  <Tab label="Add Text" value="content" />
                  <Tab label="Upload File" value="file" />
                  <Tab label="Add URL" value="url" />
                </Tabs>
              </Box> */}
      </DialogContent>
      <DialogActions>
        <WriteWithAIActionButtons onGenerate={onGenerate} onSelect={onSelect} />
      </DialogActions>
    </Dialog>
  );
}

export default WriteWithAIModal;

const Note = styled(Typography, { label: 'Note' })(({ theme }) => ({
  fontSize: 14,
  color: theme.palette.custom.tuna,
  textAlign: 'left',
  marginTop: 4,
  marginBottom: 8,
}));

const Title = styled(Typography, { label: 'Title' })(({ theme }) => ({
  fontSize: 20,
  fontWeight: 700,
  color: theme.palette.custom.link,
  marginLeft: 8,
}));
